import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { StyledLinkProps } from './types';

export const StyledLink = styled(Link)<StyledLinkProps & { color?: string }>`
  color: ${({ color }) => color || 'var(--brand-green)'};
  transition: color 160ms ease, opacity 160ms ease;
  text-decoration: none;
  line-height: 1;
  &:hover {
    opacity: 0.75;
  }
`;
